export default {"src":"/_next/static/media/clockGreyFilled.a37b89b2.svg","height":24,"width":24};